export const aiSummaryIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M11.7616 2.13826C11.3253 2.13826 10.9274 2.40779 10.7682 2.81593L7.91381 10.0547L0.675043 12.9091C0.475889 12.9883 0.305088 13.1254 0.18475 13.3028C0.0644112 13.4801 7.82013e-05 13.6895 7.82013e-05 13.9038C7.82013e-05 14.1181 0.0644112 14.3275 0.18475 14.5049C0.305088 14.6822 0.475889 14.8193 0.675043 14.8985L7.91381 17.7529L10.7682 24.9917C10.8474 25.1909 10.9846 25.3617 11.1619 25.482C11.3392 25.6023 11.5486 25.6667 11.7629 25.6667C11.9772 25.6667 12.1866 25.6023 12.364 25.482C12.5413 25.3617 12.6784 25.1909 12.7576 24.9917L15.6121 17.7529L22.8508 14.8985C23.05 14.8193 23.2208 14.6822 23.3411 14.5049C23.4614 14.3275 23.5258 14.1181 23.5258 13.9038C23.5258 13.6895 23.4614 13.4801 23.3411 13.3028C23.2208 13.1254 23.05 12.9883 22.8508 12.9091L15.6121 10.0547L12.7576 2.81593C12.6779 2.61667 12.5405 2.44574 12.3631 2.32501C12.1857 2.20428 11.9763 2.13926 11.7616 2.13826ZM21.3877 0L20.0272 2.91604L17.1111 4.27652L20.0272 5.63956L21.3877 8.5556L22.7481 5.63956L25.6667 4.27908L22.7507 2.91861L21.3877 0Z"
      fill="var(--custom-ai-summary-icon-color, #F37053)"
    />
  </svg>
);
